import { initialState, medication } from './state';

export function setSubjectId(state, subjectId) {
  Object.assign(state, { subjectId });
}

export function setGender(state, gender) {
  Object.assign(state, { gender });
}

export function setBirthYear(state, birthYear) {
  Object.assign(state, { birthYear });
}

export function setStartDate(state, startDate) {
  Object.assign(state, { startDate });
}
export function resetData(state) {
  Object.assign(state, initialState(), { subjectId: state.subjectId });
}

export function reset(state) {
  Object.assign(state, initialState());
}
